import React from "react";
import { NavLink } from "react-router-dom";

export default function MenuItem({

    icon,
    title,
    to,
    onClick

}) {

    return (

        <NavLink

            to={to}

            onClick={onClick}

            className={({ isActive }) =>

                isActive
                    ? "drawer-item active"
                    : "drawer-item"

            }

        >

            <span className="drawer-icon">

                {icon}

            </span>

            <span className="menu-text">

                {title}

            </span>

        </NavLink>

    );

}